import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ForwardIcon from '@mui/icons-material/Forward';
import ReplyIcon from '@mui/icons-material/Reply';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { Grid, Box, Tooltip, styled } from '@mui/material';
import {
  Item,
  timeSince,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsColors,
  WsTypoVariants,
} from 'wisestep-base';

import { getTimeString, singleDataType, singleDataHandleType } from '../helper';

import { FromLabel } from './FromEmailField';
import { Attachments } from './InboxAttachments';
import { ToFormField } from './ToEmailField';
const buttonArray = [
  {
    name: 'Reply',
    icon: <ReplyIcon sx={{ color: "text.primary'" }} />,
  },
  {
    name: 'Reply All',
    icon: <ReplyAllIcon sx={{ color: "text.primary'" }} />,
  },
  {
    name: 'Forward',
    icon: <ForwardIcon sx={{ color: "text.primary'" }} />,
  },
];
type InboxContentProps = {
  handleContent: singleDataType;
  inboxActionHandler: (name: string) => void;
  singleDataHandle: singleDataHandleType;
};

export const IFrame = styled('iframe')(() => ({
  height: '550px',
  width: '100%',
  border: 0,
  overflowY: 'auto',
}));

export const SmallBoxWithRadiusStyle = styled(Box)(() => ({
  border: '1px solid ',
  borderColor: WsColors.TheBlues500,
  backgroundColor: WsColors.White,
  borderRadius: 8,
  paddingLeft: 12,
  paddingRight: 8,
  height: 32,
  marginBottom: 6,
  marginRight: 6,
  alignItems: 'center',
}));

export const InboxContent = ({
  handleContent,
  inboxActionHandler,
  singleDataHandle,
}: InboxContentProps) => (
  <Grid height={900} sx={{ overflowY: 'auto' }} container xs={7.5}>
    <Box bgcolor="white" sx={{ borderColor: 'text.primary', position: 'relative', width: '100%' }}>
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            margin: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AccountCircleIcon sx={{ fontSize: '4rem' }} />
        </Box>
        <Box sx={{ display: 'inline-block' }}>
          <Grid container>
            <Grid>
              <ToFormField content={handleContent.content} showDrawer={handleContent.showDrawer} />
            </Grid>
            <Grid sx={{ pt: 1, pb: 1 }}>
              <WsTypography color={WsTypoColors.QUATERNARY} variant={WsTypoVariants.SUB_TITLE}>
                {getTimeString(handleContent.content.sent_on)}(
                {timeSince(String(handleContent.content.sent_on))})
              </WsTypography>
            </Grid>
          </Grid>
          <FromLabel label={'From'} handleContent={handleContent} />
        </Box>
      </Box>
      <Grid item xs={12} sx={{ position: 'relative', pl: '1.5em', pr: '0.5em', pt: '2em' }}>
        {handleContent.content && (
          <IFrame id="imageviewer" title="imageviewer" src={handleContent.content.message} />
        )}

        <Box
          sx={{
            marginTop: '5em',
            position: 'bottom',
            bottom: 0,
          }}
        >
          {Attachments(handleContent, singleDataHandle).map((item) => item)}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              position: 'relative',
            }}
          >
            {buttonArray.map((single, index) => (
              <Item key={index}>
                <SmallBoxWithRadiusStyle key={index}>
                  <Tooltip title={single.name}>
                    <Box textAlign="center">
                      <WsButton
                        startIcon={single.icon}
                        variant="text"
                        onClick={() => inboxActionHandler(single.name)}
                      >
                        {single.name}
                      </WsButton>
                    </Box>
                  </Tooltip>
                </SmallBoxWithRadiusStyle>
              </Item>
            ))}
          </Box>
        </Box>
      </Grid>
    </Box>
  </Grid>
);
